
import {
RECEIVE_ACCOUNT_BALANCE, RECEIVE_LANGUAGE,
  // RECEIVE_ACCOUNTINFO,
  RECEIVE_REJECT_RECORDS, RECEIVE_USERINFO
} from './mutation-type'

export default {
  [RECEIVE_LANGUAGE] (state, { lang }) {
    state.selectLang = lang
  },
  [RECEIVE_REJECT_RECORDS] (state, { option }) {
    state.rejectRecords = option
  },
  // [RECEIVE_TRADE_ACCOUNT_LIST] (state, { tradeAccountList }) {
  //   state.tradeAccountList = tradeAccountList
  // },
  // [RECEIVE_TRADE_ACCOUNT_ORDERID] (state, orderId) {
  //   state.orderId = orderId
  // },
  // [RECEIVE_TRADE_ACCOUNT_RECORDS] (state, { applyTradeRecords }) {
  //   state.applyTradeRecords = applyTradeRecords
  // },
  [RECEIVE_USERINFO] (state, data) {
    // state.clientProfile = { userInfo: data.userInfo, type: data.type }
    state.clientProfile = { userInfo: data }
    // state.accountInfo = data.accountInfo
  },
  // [RECEIVE_ACCOUNTINFO] (state, data) {
  //   state.accountInfo = data
  // },
  setAccountNumbers (state, arr) {
    state.AccountNumbers = arr
  },
  setValueAccountNumber (state, accountNumber) {
    state.valueAccountNumber = accountNumber
  },
  setLayout (state, payload) {
    if (payload && payload.navPos !== undefined) {
      state.layout.navPos = payload.navPos
    }
    if (payload && payload.toolbar !== undefined) {
      state.layout.toolbar = payload.toolbar
    }
    if (payload && payload.footer !== undefined) {
      state.layout.footer = payload.footer
    }
    if (payload && payload.boxed !== undefined) {
      state.layout.boxed = payload.boxed
    }
    if (payload && payload.roundedCorners !== undefined) {
      state.layout.roundedCorners = payload.roundedCorners
    }
    if (payload && payload.viewAnimation !== undefined) {
      state.layout.viewAnimation = payload.viewAnimation
    }
  },
  setLogin (state, payload) {
    state.logged = true
  },
  setLogout (state, payload) {
    state.layout.navPos = null
    state.layout.toolbar = null
    state.logged = false
  },
  setSplashScreen (state, payload) {
    state.splashScreen = payload
  },
  setUser (state, val) {
    state.user = val
    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  setAccountTypeObj (state, val) {
    state.accountTypeObj = val
  },
  setTransferAccountInfos (state, val) {
    state.transferAccountInfos = val
  },
  setCurLang (state, val) {
    console.log(val)
    state.selectLang = val
  },
  setLogoutDialog (state, val) {
    state.logoutDialog = val
  },
  setToolbar (state, val) {
    state.layout.toolbar = val
  },
  setSource (state, val) {
    state.source = val
  },
  setAccountInfo (state, val) {
    state.accountInfo = val
  },
  setAllAccountInfo (state, val) {
    state.allAccountInfo = val
  },
  setUserInfo (state, val) {
    state.userInfo = val
  },
  setIdToken (state, val) {
    state.idToken = val
  },
  setAccessToken (state, val) {
    state.accessToken = val
  },
  setAccountOpeningAgreement (state, val) {
    state.accountOpeningAgreement = val
  },
  setBullion (state, val) {
    state.setBullionConfig = val
  },
  [RECEIVE_ACCOUNT_BALANCE] (state, data) {
    state.accountBalance = data
  },
  setSubBankAccounts (state, val) {
    state.subBankAccounts = val
  },
  setAccountOpening (state, val) {
    state.isAccountOpening = val
  },
  setFilterSPTradingAccountList(state, val) {
    state.filterSPTradingAccountList = val
  }
}
